import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AiAssistantV2 from '../components/Frontend/AiAssistantV2/AiAssistantV2';

export const chatRouteV2 = (
  <Route path="/ai_assistant_2" element={<MainLayout />}>
    <Route path="" element={
      
      <><AiAssistantV2/></>
      
      } />
  </Route>
);
